module.exports = __webpack_public_path__ + "img/avantage3.2c03d546.png";